import React from 'react';
import { SvgIcon, SvgIconProps } from "@mui/material";

export const NoteIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M14.75 14c-.2 0-.39.07-.53.22a.72.72 0 0 0-.22.53V19H5.75a.72.72 0 0 1-.53-.22.72.72 0 0 1-.22-.53V5.75c0-.2.07-.39.22-.53A.72.72 0 0 1 5.75 5h12.5c.2 0 .39.07.53.22a.7.7 0 0 1 .22.53V14h-4.25Zm4.03 1.72-3.06 3.06a.72.72 0 0 1-.53.22H15v-4h4v.19c0 .2-.07.38-.22.53Z" />
    </SvgIcon>
);
